/**
 * Optional project-scoped navigation for concept-group links/codes in chat.
 *
 * Concept-group references render in many chat surfaces (markdown text, SQL
 * knowledge codes). Historically clicking one opened the
 * ``ConceptGroupDetailsDialog`` modal. In the agent-first project page we'd
 * rather route to the in-pane artifact (``/projects/:pid/concept-group/:id``)
 * so the user gets the breadcrumb back — but the standalone
 * ``/epi-study-agent`` surface has no such route, so it must keep the modal.
 *
 * Rather than thread a navigate handler through every Markdown call site, the
 * project chat provides it via this context. When ``navigateToConceptGroup`` is
 * set, a concept-group link navigates; when it's absent (no project context),
 * callers fall back to opening the modal.
 *
 * TODO: cleanup with research_assistant_gen_3 ff
 */

import { createContext, useContext } from 'react';

export interface ConceptGroupNavContextValue {
  /** Route to the created concept group's in-pane detail; absent → open the modal. */
  navigateToConceptGroup?: (conceptGroupId: string) => void;
}

const ConceptGroupNavContext = createContext<ConceptGroupNavContextValue>({});

export const ConceptGroupNavProvider = ConceptGroupNavContext.Provider;

export const useConceptGroupNav = (): ConceptGroupNavContextValue =>
  useContext(ConceptGroupNavContext);
